import { render, staticRenderFns } from "./BuyOcPlusCongratulations.vue?vue&type=template&id=9f369330"
import script from "./BuyOcPlusCongratulations.vue?vue&type=script&lang=js"
export * from "./BuyOcPlusCongratulations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseButton: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/22072026_100728/resources/assets/marketplace/components/BaseButton.vue').default})
